import { Record } from "immutable";
import moment from "moment";
import { CatalogProcessingStatuses } from "components/import-linesheet/import-linesheet-types";

const defaults = {
    id: undefined,
    brand_id: undefined,
    title: "",
    type: "custom-list",
    active: false,
    __meta: {},
    cover: undefined,
    portrait_image: undefined,
    archived: false,
    owner_account_id: undefined,
    description: "",
    default_pdf_template: "",
    restrictions: [],
    links: [],
    created_on: undefined,
    modified_on: undefined,
    delivery_window_start: undefined,
    delivery_window_end: undefined,
    prebook: false,
    hide_when_expired: false,
    visible_to_guest_buyers: true,
    __out_of_range: undefined,
    entries: undefined,
    processing: CatalogProcessingStatuses.Initial,
    es_synced_on: null,
};

class CatalogRecord extends Record(defaults) {
    get _link() {
        const type = this.type === "linesheet" ? "linesheet" : "list";
        return `/brand/${this.brand_id}/${type}/${this.id}`;
    }

    get _parentLink() {
        const type = this.type === "linesheet" ? "linesheets" : "lists";
        return `/brand/${this.brand_id}/${type}`;
    }

    get _coverThumb() {
        if (this.cover) {
            const [name, ext = "jpg"] = this.cover.split(".");
            return `//cdn1.nuorder.com/catalog_cover/${name}T.${ext}`;
        }
        return undefined;
    }

    get _portraitImage() {
        if (this.portrait_image) {
            const [name, ext = "jpg"] = this.portrait_image.split(".");
            return `//cdn1.nuorder.com/catalog_portrait_image/${name}.${ext}`;
        }
        return undefined;
    }

    get _cover() {
        if (this.cover) {
            const [name, ext = "jpg"] = this.cover.split(".");
            return `//cdn1.nuorder.com/catalog_cover/${name}.${ext}`;
        }
        return undefined;
    }

    get _editable() {
        return this.__meta.__actions ? this.__meta.__actions.some((action) => action.__key === "__edit") : false;
    }

    get _deliveryWindowLabel() {
        let label;
        if (this.delivery_window_start && this.delivery_window_end) {
            const start = moment.utc(this.delivery_window_start).format("MMM DD, YYYY");
            const end = moment.utc(this.delivery_window_end).format("MMM DD, YYYY");
            label = `${start} - ${end}`;
        }

        return label;
    }

    get _getCatalogDisplayType() {
        return this.type === "linesheet" ? "Linesheet" : "List";
    }

    isExpired(minimumDeliveryWindow) {
        if (this.delivery_window_start && this.delivery_window_end && minimumDeliveryWindow) {
            const cutOffDate = moment.utc().endOf("day").add(minimumDeliveryWindow, "days").valueOf();

            // Calculate
            const unixEnd = Number(this.delivery_window_end);

            return cutOffDate > unixEnd;
        } else {
            return false;
        }
    }

    isProcessing() {
        return this.processing === CatalogProcessingStatuses.ProductUpload;
    }
}

export default CatalogRecord;
